/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, Fragment } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PromoUsageListAction } from "../../../../Redux/Actions/PaymentAction";
import { formatDate, calculateTotalPages } from "../../../../utils/Helper";
import {
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Pagination,
} from "@mui/material";
import Breadcrumb from "../../../DefaultComponent/BreadCrumb";
import Spinner from "../../../DefaultComponent/Spinner";
import { S3MediaURL } from "../../../../Config/Config";

const PromoUsage: React.FC = () => {
  const { promo_id } = useParams<{ promo_id: string }>();
  const dispatch = useDispatch<any>();

  const usageData = useSelector((state: any) => state.PromoUsageListData);

  const [usageList, setUsageList] = useState<any[]>([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  const fetchUsage = (pageNum = page) => {
    setLoading(true);
    let params = `${promo_id}/?page=${pageNum}&page_size=${rowsPerPage}`;
    dispatch(PromoUsageListAction(params));
  };

  useEffect(() => {
    fetchUsage();
  }, [dispatch, promo_id, page]);

  useEffect(() => {
    if (usageData?.status) {
      setLoading(false);
      setUsageList(usageData?.data?.row);
      setCount(usageData?.data?.total_count);
    }
  }, [usageData]);

  return (
    <>
      {loading && <Spinner />}

      <div
        className="page-wrapper card"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="col-md-12">
          <Breadcrumb
            pageTitle="Promo Usage"
            breadcrumbs={[
              {
                label: "Promo Codes",
                path: "/payments/promo",
                isActive: false,
              },
              {
                label: "Usage",
                path: `/payments/promo/${promo_id}/usage`,
                isActive: true,
              },
            ]}
          />
        </div>

        <Box sx={{ m: 2 }}>
          <TableContainer component={Paper}>
            <Table aria-label="Promo Usage Table">
              <TableHead sx={{ backgroundColor: "#0555c8" }}>
                <TableRow>
                  <TableCell sx={{ color: "white", textAlign: "center" }}>
                    S.No
                  </TableCell>
                  <TableCell sx={{ color: "white", textAlign: "center" }}>
                    Entity Type
                  </TableCell>
                  <TableCell sx={{ color: "white", textAlign: "center" }}>
                    Entity ID
                  </TableCell>
                  <TableCell sx={{ color: "white", textAlign: "center" }}>
                    Entity Name
                  </TableCell>
                  <TableCell sx={{ color: "white", textAlign: "center" }}>
                    Entity Email
                  </TableCell>
                  <TableCell sx={{ color: "white", textAlign: "center" }}>
                    Used At
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {usageList.length > 0 ? (
                  usageList.map((u, idx) => (
                    <TableRow key={u.id}>
                      <TableCell align="center">
                        {(page - 1) * rowsPerPage + idx + 1}
                      </TableCell>
                      <TableCell align="center">{u.entity_type}</TableCell>
                      <TableCell align="center">{u.entity_id}</TableCell>
                      <TableCell align="center">
                        <div className="d-flex justify-content-center align-items-center gap-1">
                          <div
                            className="col-md-3 text-center"
                            style={{ width: "35px", height: "35px" }}
                          >
                            <img
                              src={
                                u.user_data?.logo
                                  ? S3MediaURL + u.user_data.logo
                                  : u.org_data?.logo
                                  ? S3MediaURL + u.org_data.logo
                                  : "/default-profile-img.png"
                              }
                              alt="Organization"
                              style={{ width: 35, height: 35 }}
                              className="rounded-circle"
                            />
                          </div>
                          {u.user_data?.fullname ??
                            u.org_data?.org_name ??
                            "N/A"}
                        </div>
                      </TableCell>
                      <TableCell align="center">{u.entity_email}</TableCell>
                      <TableCell align="center">
                        {formatDate(u.used_at)}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No usage found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
            <Stack spacing={2}>
              <Pagination
                count={calculateTotalPages(count, rowsPerPage)}
                page={page}
                onChange={(_, newPage) => setPage(newPage)}
                color="primary"
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          </Box>
        </Box>
      </div>
    </>
  );
};

export default PromoUsage;
